import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import authenticateRoutes from '@/router/authenticate-routes';
import authenticatedRoutes from '@/router/authenticated-routes';
import publicRoutes from '@/router/public-routes';

const routes: Array<RouteRecordRaw> = [
  ...publicRoutes,
  ...authenticateRoutes,
  ...authenticatedRoutes,
  {
    path: '/*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "portal" */ '@/views/404/Error404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
